import React from "react";
import { Button, Card, CardContent } from "@mui/material";
import { RobotoTypo } from "../../utils/Typographies";
import { useTranslation } from "react-i18next";

const UploadedDocumentsView = ({ uploadedDocuments, baseUrl }) => {
    console.log("uploadedDocuments", uploadedDocuments);
    const {t} = useTranslation()

    const requiredDocs = [
  { name: "passport", label: "Passport", required: false },
  { name: "transcripts", label: "Transcripts for the past three years", required: false },
  { name: "graduationCertificate", label: "Graduation Certificate", required: false },
  { name: "idPhoto", label: "ID Photo", required: false },
  { name: "other", label: "Other (Optional)", required: false },
];

// ✅ Safe conversion — check if uploadedDocuments is valid
  const converted = Object.entries(uploadedDocuments || {}).reduce((acc, [key, value]) => {
    const doc = requiredDocs.find(doc => doc.name === key);
    if (doc) acc[doc.label] = value;
    return acc;
  }, {});

  // ✅ If still empty after conversion
  if (!Object.keys(converted).length) {
    return <p>{t("No uploaded documents found")}</p>;
  }

  return (
    <div
      style={{
        display: "grid",
        gap: "1rem",
        gridTemplateColumns: "repeat(auto-fill, minmax(100%, 1fr))",
      }}
    >
      {Object.entries(converted).map(([key, doc]) => (
        <Card key={key} variant="outlined" sx={{ textAlign: "center" }}>
          <CardContent>
            <RobotoTypo style={{ textTransform: "capitalize", marginBottom: "0.5rem" }}>
              {t(key)}
            </RobotoTypo>

            {doc ? (
              <>
                {/* ✅ Preview section */}
                {doc.mimeType.startsWith("image/") ? (
                  <img
                    src={`${baseUrl}/${doc.filePath.replace(/\\/g, "/")}`}
                    alt={doc.fileName}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                ) : doc.mimeType === "application/pdf" ? (
                  <iframe
                    src={`${baseUrl}/${doc.filePath.replace(/\\/g, "/")}`}
                    title={doc.fileName}
                    width="100%"
                    height="400px"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  ></iframe>
                ) : (
                  <div
                    style={{
                      height: "180px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px dashed #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <p>{doc.mimeType || "Unknown file type"}</p>
                  </div>
                )}

                {/* ✅ File Info */}
                <p
                  style={{
                    marginTop: "8px",
                    fontSize: "0.9rem",
                    color: "#444",
                    wordBreak: "break-all",
                  }}
                >
                  {doc.fileName}
                </p>

                {/* ✅ Download Button */}
                <Button variant="contained" color="primary">
                
                <a
                  href={`${baseUrl}/${doc.filePath.replace(/\\/g, "/")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  style={{
                    display: "inline-block",
                    marginTop: "6px",
                    padding: "6px 12px",
                    backgroundColor: "#1976d2",
                    color: "white",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontSize: "0.85rem",
                  }}
                >
                  Download
                </a>
                </Button>
              </>
            ) : (
              <p style={{ color: "gray" }}>No file uploaded</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default UploadedDocumentsView;
